// extracted by mini-css-extract-plugin
export var divider = "_g4-7";
export var itemsToggle = "_g4-8";
export var mergeModal = "_g4-1";
export var optionCard = "_g4-4";
export var radioGroup = "_g4-6";
export var radioOption = "_g4-0";
export var selected = "_g4-5";
export var shipmentOptions = "_g4-2";
export var tableOptions = "_g4-3";